export const themeColors = [
  {
    id: "theme1",
    name: "Ocean Breeze",
    Primary: { start: "#2c3f51", end: "#243241" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "white",
    Secondary: { start: "#315195", end: "#14213D" },
    gradient: { start: "#08c", middle: "#fff", end: "#2c3e50" },
  },
  {
    id: "theme2",
    name: "Sunny Dusk",
    Primary: { start: "#F6A21E", end: "#efae4b" },
    PrimaryTextColor: "black",
    SecondaryTextColor: "black",
    Secondary: { start: "#000000", end: "#000000" },
    gradient: { start: "#000000", middle: "#fff", end: "#ffc011" },
  },
  {
    id: "theme3",
    name: "Teal Wave",
    Primary: { start: "#098d91", end: "#0f686b" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "white",

    Secondary: { start: "#098d91", end: "#098d93" },
    gradient: { start: "#088d92", middle: "#fff", end: "#0f686c" },
  },
  {
    id: "theme4",
    name: "Steel Shadow",
    Primary: { start: "#383140", end: "#000" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "white",

    Secondary: { start: "#383140", end: "#383140" },
    gradient: { start: "#383140", middle: "#fff", end: "#000" },
  },
  {
    id: "theme5",
    name: "Mint Coral",
    Primary: { start: "#4abdac", end: "#fc4a1a" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "white",

    Secondary: { start: "#4bbcac", end: "#4bbcac" },
    gradient: { start: "#4abdac", middle: "#fff", end: "#f48221" },
  },
  {
    id: "theme6",
    name: "Rose Glow",
    Primary: { start: "#900e50", end: "#900e50" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "white",

    Secondary: { start: "#e83c76", end: "#e83c76" },
    gradient: { start: "#e63d77", middle: "#fff", end: "#8c1050" },
  },
  {
    id: "theme7",
    name: "Earth Teal",
    Primary: { start: "#116257", end: "#0e453e" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "white",

    Secondary: { start: "#8a4e00", end: "#573201" },
    gradient: { start: "#8a4e00", middle: "#fff", end: "#116257" },
  },
  {
    id: "theme8",
    name: "Coral Night",
    Primary: { start: "#fd8f3b", end: "#fd3523" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "black",

    Secondary: { start: "#000000", end: "#000000" },
    gradient: { start: "#000000", middle: "#fff", end: "#fe582c" },
  },
  {
    id: "theme9",
    name: "Forest Blue",
    Primary: { start: "#16ACAB", end: "#16ACAB" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "black",

    Secondary: { start: "#000000", end: "#000000" },
    gradient: { start: "#000000", middle: "#fff", end: "#16acab" },
  },
  {
    id: "theme10",
    name: "Night Aqua",
    Primary: { start: "#A4DC60", end: "#4F9F21" },
    PrimaryTextColor: "white",
    SecondaryTextColor: "black",

    Secondary: { start: "#315195", end: "#14213D" },
    gradient: { start: "#315195", middle: "#fff", end: "#14213D" },
  },
];
